export default __webpack_public_path__ + "static/media/Geometrie_complesse_Arturo_Armenti_20_x_60.74040149.jpg";